import {
  Box,
  Button,
  CircularProgress,
  List,
  TextField,
  Typography,
} from '@mui/material'
import { grey } from '@mui/material/colors'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import useIdentities from '../../../hooks/api/useIdentities'
import useOtherAvatar from '../../../hooks/api/useOtherAvatar'
import useCurrentIdentity from '../../../hooks/useCurrentIdentity'
import { authedAxios } from '../../../utils'

import Note from './Note'
import DeleteConfirmModal from '../DeleteConfirmModal'

const TicketNotes = ({
  ticket,
  notes = [],
  addNote,
  addToNotesToSaveQueue,
  removeFromNotesToSaveQueue,
  notesToSaveQueue,
  editNote,
  removeNote,
}) => {
  const avatarsNeeded = [
    ...new Set(notes.map((t) => t.authorId).filter((id) => !!id)),
  ]

  const { id: customerId } = useParams()

  const { avatarUrlsMap } = useOtherAvatar(avatarsNeeded)
  const { identities, isLoading } = useIdentities()

  const [newNoteText, setNewNoteText] = useState('')

  const [isDeleting, setIsDeleting] = useState(null)

  const { currentIdentity } = useCurrentIdentity()

  const localNotes = ticket ? notes : notesToSaveQueue

  const createNote = () => {
    if (!ticket) {
      const newNote = {
        noteContent: newNoteText,
        authorId: currentIdentity.id,
        createdOn: new Date(),
      }
      setNewNoteText('')
      return addToNotesToSaveQueue(newNote)
    }

    return authedAxios
      .post(`/api/customer/${customerId}/ticket/${ticket.id}/note`, {
        noteContent: newNoteText,
      })
      .then((res) => {
        setNewNoteText('')
        addNote(ticket.id, res.data.note)
      })
  }

  const updateNote = (note) => {
    if (!ticket) {
      return addToNotesToSaveQueue(note, note.id)
    }

    editNote(note)

    return authedAxios
      .put(`/api/customer/${customerId}/ticket/${ticket.id}/note/${note.id}`, {
        noteContent: note.noteContent,
      })
      .then((res) => {})
      .catch(() => {})
  }

  const deleteNote = (note) => {
    if (!ticket) {
      return removeFromNotesToSaveQueue(note)
    }

    removeNote(note)

    return authedAxios
      .delete(`/api/customer/${customerId}/ticket/${ticket.id}/note/${note.id}`)
      .then((res) => {})
      .catch(() => {})
  }

  if (isLoading) return <CircularProgress />

  return (
    <>
      <DeleteConfirmModal
        isOpen={!!isDeleting}
        onSubmit={() => {
          deleteNote(isDeleting)
          setIsDeleting(null)
        }}
        onClose={() => setIsDeleting(null)}
        deleteString={'this note'}
      />
      {localNotes.length === 0 && (
        <Typography sx={{ color: grey['600'] }}>
          <i>No notes</i>
        </Typography>
      )}
      <List sx={{ maxHeight: '400px', overflow: 'scroll' }}>
        {localNotes.map((n, i) => {
          return (
            <Note
              n={n}
              key={n.id}
              i={i}
              identities={identities}
              avatarUrlsMap={avatarUrlsMap}
              canEdit={currentIdentity.id === n.authorId}
              updateNote={(newVal) => updateNote(newVal)}
              deleteNote={() => setIsDeleting(n)}
            />
          )
        })}
      </List>
      <Box sx={{ mt: 2 }}>
        <TextField
          fullWidth
          multiline
          rows={3}
          placeholder={'Add a note'}
          value={newNoteText}
          onChange={(e) => setNewNoteText(e.target.value)}
        />
        {newNoteText && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
            <Button variant='outlined' onClick={createNote}>
              Save note
            </Button>
          </Box>
        )}
      </Box>
    </>
  )
}

export default TicketNotes
